import React, { useState } from 'react';
import {  MenuIcon, XIcon } from '@heroicons/react/solid'
import { Link } from 'react-router-dom';

const Header = () => {
         const [open , setOpen] = useState(false)
         const clickToopen =() =>{
                   setOpen(!open)
         }
          return (
                   <div className='text-center'>
                              <div className='w-full flex justify-between md:flex md:justify-center items-center p-4  md:p-6 bg-white border sticky top-0'>
                              <img  className='w-10 hidden md:block md:mx-4 m-auto' src="https://img.icons8.com/ios/2x/learning.png" alt="" />
                              <h1 className='font-bold  md:block text-3xl text-center text-blue-900'>Learn With Zaman</h1>  
                             <div onClick={clickToopen}>
                             {open ?<XIcon className='w-10 h-10  text-black md:hidden' />  : <MenuIcon  className='w-10 h-10  text-black md:hidden'/>}
                             </div>
                             
                    </div>
                     <nav className={`font-bold text-xl bg-gray-800  md:flex justify-center py-3 h-[100vh] absolute duration-500 ease-in w-full ${open ? 'top-15 ': 'top-[-1050px]'}`}>
                     <Link className='md:mx-4 mb-2 block text-blue-700 '  to={'/'}>Home</Link>
                     <Link className='md:mx-4 mb-2 block text-blue-700  '  to={'/'}>Quizzes</Link>
                     <Link className='md:mx-4 block text-blue-700 '  to={'/'}>About Us</Link>

           </nav>
                   </div>
          );
};

export default Header;